import { render, staticRenderFns } from "./index.vue?vue&type=template&id=87d5859c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=87d5859c&prod&lang=scss&module=true"
import style1 from "./index.vue?vue&type=style&index=1&id=87d5859c&prod&lang=scss"
import style2 from "./index.vue?vue&type=style&index=2&id=87d5859c&prod&lang=scss&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "87d5859c",
  null
  
)

export default component.exports